// extracted by mini-css-extract-plugin
export default {"wrapper":"Questionnaire_wrapper__sdne5","questions":"Questionnaire_questions__kET6q","likeAnimation":"Questionnaire_likeAnimation__6r6sF"};